import axios from 'axios';
import { getHeaders, getToken } from './auth';

function post(object) {
    const { url, data } = object;

    return new Promise((resolve, reject) => {
        axios({
            method: 'POST',
            url,
            headers: getHeaders(getToken()),
            data,
        })
            .then((response) => resolve(response))
            .catch((error) => reject(error));
    });
}

function patch(object) {
    const { url, data } = object;

    return new Promise((resolve, reject) => {
        axios({
            method: 'PATCH',
            url,
            headers: getHeaders(getToken()),
            data,
        })
            .then((response) => resolve(response))
            .catch((error) => reject(error));
    });
}

function put(object) {
    const { url, data } = object;

    return new Promise((resolve, reject) => {
        axios({
            method: 'PUT',
            url,
            headers: getHeaders(getToken()),
            data,
        })
            .then((response) => resolve(response))
            .catch((error) => reject(error));
    });
}

function get(object) {
    const { url } = object;

    return new Promise((resolve, reject) => {
        axios({
            method: 'GET',
            url,
            headers: getHeaders(getToken()),
        })
            .then((response) => resolve(response))
            .catch((error) => reject(error));
    });
}

function remove(object) {
    const { url } = object;

    return new Promise((resolve, reject) => {
        axios({
            method: 'DELETE',
            url,
            headers: getHeaders(getToken()),
        })
            .then((response) => resolve(response))
            .catch((error) => reject(error));
    });
}

export {
    post, get, remove, patch, put,
};

export default post;
